import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-18cfc7b0")

_pushScopeId("data-v-18cfc7b0")
const _hoisted_1 = { class: "board-card-description" }
const _hoisted_2 = { class: "board-card-description__item" }
const _hoisted_3 = { class: "board-card-description__heading" }
const _hoisted_4 = { class: "board-card-description__prices" }
const _hoisted_5 = { class: "board-card-description__price" }
const _hoisted_6 = { class: "board-card-description__price" }
const _hoisted_7 = { class: "board-card-description__price" }
const _hoisted_8 = { class: "board-card-description__price" }
const _hoisted_9 = { class: "board-card-description__item" }
const _hoisted_10 = { class: "board-card-description__heading" }
const _hoisted_11 = { class: "board-card-description__prices" }
const _hoisted_12 = { class: "board-card-description__price" }
const _hoisted_13 = { class: "board-card-description__price" }
const _hoisted_14 = { class: "board-card-description__price" }
const _hoisted_15 = { class: "board-card-description__price" }
const _hoisted_16 = { class: "board-card-description__item" }
const _hoisted_17 = { class: "board-card-description__heading" }
const _hoisted_18 = { class: "board-card-description__prices" }
const _hoisted_19 = { class: "board-card-description__price" }
const _hoisted_20 = { class: "board-card-description__price" }
const _hoisted_21 = { class: "board-card-description__price" }
const _hoisted_22 = { class: "board-card-description__item" }
const _hoisted_23 = { class: "board-card-description__heading" }
const _hoisted_24 = { class: "board-card-description__prices" }
const _hoisted_25 = { class: "board-card-description__price" }
const _hoisted_26 = { class: "board-card-description__price" }
const _hoisted_27 = { class: "board-card-description__price" }
const _hoisted_28 = { class: "board-card-description__price" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('boardCard.toEmploy')), 1),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("span", {
            class: "board-card-description__category",
            style: _ctx.getCategoryStyles(_ctx.upgradeConfig.categoryOne[_ctx.$i18n.locale])
          }, _toDisplayString(_ctx.upgradeConfig.categoryOne[_ctx.$i18n.locale]), 5),
          _createVNode("span", null, _toDisplayString(_ctx.prices.categoryOne.buy), 1),
          (_ctx.actions[_ctx.POSSIBLE_ACTIONS.GET_CATEGORY_ONE] && _ctx.actionAvailable)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                class: "button--small button--white",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleSelectAction(_ctx.POSSIBLE_ACTIONS.GET_CATEGORY_ONE)))
              }, _toDisplayString(_ctx.$t('boardCard.buy')), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("span", {
            class: "board-card-description__category",
            style: _ctx.getCategoryStyles(_ctx.upgradeConfig.categoryTwo[_ctx.$i18n.locale])
          }, _toDisplayString(_ctx.upgradeConfig.categoryTwo[_ctx.$i18n.locale]), 5),
          _createVNode("span", null, _toDisplayString(_ctx.prices.categoryTwo.buy), 1),
          (_ctx.actions[_ctx.POSSIBLE_ACTIONS.GET_CATEGORY_TWO] && _ctx.actionAvailable)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                class: "button--small button--white",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSelectAction(_ctx.POSSIBLE_ACTIONS.GET_CATEGORY_TWO)))
              }, _toDisplayString(_ctx.$t('boardCard.buy')), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("span", {
            class: "board-card-description__category",
            style: _ctx.getCategoryStyles(_ctx.upgradeConfig.categoryThree[_ctx.$i18n.locale])
          }, _toDisplayString(_ctx.upgradeConfig.categoryThree[_ctx.$i18n.locale]), 5),
          _createVNode("span", null, _toDisplayString(_ctx.prices.categoryThree.buy), 1),
          (_ctx.actions[_ctx.POSSIBLE_ACTIONS.GET_CATEGORY_THREE] && _ctx.actionAvailable)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                class: "button--small button--white",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleSelectAction(_ctx.POSSIBLE_ACTIONS.GET_CATEGORY_THREE)))
              }, _toDisplayString(_ctx.$t('boardCard.buy')), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("span", {
            class: "board-card-description__category",
            style: _ctx.getCategoryStyles(_ctx.upgradeConfig.categoryFour[_ctx.$i18n.locale])
          }, _toDisplayString(_ctx.upgradeConfig.categoryFour[_ctx.$i18n.locale]), 5),
          _createVNode("span", null, _toDisplayString(_ctx.prices.categoryFour.buy), 1),
          (_ctx.actions[_ctx.POSSIBLE_ACTIONS.GET_CATEGORY_FOUR] && _ctx.actionAvailable)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                class: "button--small button--white",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleSelectAction(_ctx.POSSIBLE_ACTIONS.GET_CATEGORY_FOUR)))
              }, _toDisplayString(_ctx.$t('boardCard.buy')), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('boardCard.letGo')), 1),
      _createVNode("div", _hoisted_11, [
        _createVNode("div", _hoisted_12, [
          _createVNode("span", {
            class: "board-card-description__category",
            style: _ctx.getCategoryStyles(_ctx.upgradeConfig.categoryOne[_ctx.$i18n.locale])
          }, _toDisplayString(_ctx.upgradeConfig.categoryOne[_ctx.$i18n.locale]), 5),
          _createVNode("span", null, _toDisplayString(_ctx.prices.categoryOne.sell), 1),
          (_ctx.actions[_ctx.POSSIBLE_ACTIONS.LET_GO_CATEGORY_ONE] && _ctx.actionAvailable)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                class: "button--small button--white",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleSelectAction(_ctx.POSSIBLE_ACTIONS.LET_GO_CATEGORY_ONE)))
              }, _toDisplayString(_ctx.$t('boardCard.sell')), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode("span", {
            class: "board-card-description__category",
            style: _ctx.getCategoryStyles(_ctx.upgradeConfig.categoryTwo[_ctx.$i18n.locale])
          }, _toDisplayString(_ctx.upgradeConfig.categoryTwo[_ctx.$i18n.locale]), 5),
          _createVNode("span", null, _toDisplayString(_ctx.prices.categoryTwo.sell), 1),
          (_ctx.actions[_ctx.POSSIBLE_ACTIONS.LET_GO_CATEGORY_TWO] && _ctx.actionAvailable)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                class: "button--small button--white",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleSelectAction(_ctx.POSSIBLE_ACTIONS.LET_GO_CATEGORY_TWO)))
              }, _toDisplayString(_ctx.$t('boardCard.sell')), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode("span", {
            class: "board-card-description__category",
            style: _ctx.getCategoryStyles(_ctx.upgradeConfig.categoryThree[_ctx.$i18n.locale])
          }, _toDisplayString(_ctx.upgradeConfig.categoryThree[_ctx.$i18n.locale]), 5),
          _createVNode("span", null, _toDisplayString(_ctx.prices.categoryThree.sell), 1),
          (_ctx.actions[_ctx.POSSIBLE_ACTIONS.LET_GO_CATEGORY_THREE] && _ctx.actionAvailable)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                class: "button--small button--white",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleSelectAction(_ctx.POSSIBLE_ACTIONS.LET_GO_CATEGORY_THREE)))
              }, _toDisplayString(_ctx.$t('boardCard.sell')), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_15, [
          _createVNode("span", {
            class: "board-card-description__category",
            style: _ctx.getCategoryStyles(_ctx.upgradeConfig.categoryFour[_ctx.$i18n.locale])
          }, _toDisplayString(_ctx.upgradeConfig.categoryFour[_ctx.$i18n.locale]), 5),
          _createVNode("span", null, _toDisplayString(_ctx.prices.categoryFour.sell), 1),
          (_ctx.actions[_ctx.POSSIBLE_ACTIONS.LET_GO_CATEGORY_FOUR] && _ctx.actionAvailable)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                class: "button--small button--white",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleSelectAction(_ctx.POSSIBLE_ACTIONS.LET_GO_CATEGORY_FOUR)))
              }, _toDisplayString(_ctx.$t('boardCard.sell')), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_16, [
      _createVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('boardCard.toPromote')), 1),
      _createVNode("div", _hoisted_18, [
        _createVNode("div", _hoisted_19, [
          _createVNode("span", {
            class: "board-card-description__category",
            style: _ctx.getCategoryStyles(_ctx.upgradeConfig.categoryOne[_ctx.$i18n.locale])
          }, _toDisplayString(_ctx.upgradeConfig.categoryOne[_ctx.$i18n.locale]), 5),
          _createVNode("span", null, _toDisplayString(_ctx.prices.categoryOne.promote), 1),
          (_ctx.actions[_ctx.POSSIBLE_ACTIONS.PROMOTE_CATEGORY_ONE] && _ctx.actionAvailable)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                class: "button--small button--white",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleSelectAction(_ctx.POSSIBLE_ACTIONS.PROMOTE_CATEGORY_ONE)))
              }, _toDisplayString(_ctx.$t('boardCard.promote')), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_20, [
          _createVNode("span", {
            class: "board-card-description__category",
            style: _ctx.getCategoryStyles(_ctx.upgradeConfig.categoryTwo[_ctx.$i18n.locale])
          }, _toDisplayString(_ctx.upgradeConfig.categoryTwo[_ctx.$i18n.locale]), 5),
          _createVNode("span", null, _toDisplayString(_ctx.prices.categoryTwo.promote), 1),
          (_ctx.actions[_ctx.POSSIBLE_ACTIONS.PROMOTE_CATEGORY_TWO] && _ctx.actionAvailable)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                class: "button--small button--white",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleSelectAction(_ctx.POSSIBLE_ACTIONS.PROMOTE_CATEGORY_TWO)))
              }, _toDisplayString(_ctx.$t('boardCard.promote')), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_21, [
          _createVNode("span", {
            class: "board-card-description__category",
            style: _ctx.getCategoryStyles(_ctx.upgradeConfig.categoryThree[_ctx.$i18n.locale])
          }, _toDisplayString(_ctx.upgradeConfig.categoryThree[_ctx.$i18n.locale]), 5),
          _createVNode("span", null, _toDisplayString(_ctx.prices.categoryThree.promote), 1),
          (_ctx.actions[_ctx.POSSIBLE_ACTIONS.PROMOTE_CATEGORY_THREE] && _ctx.actionAvailable)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                class: "button--small button--white",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleSelectAction(_ctx.POSSIBLE_ACTIONS.PROMOTE_CATEGORY_THREE)))
              }, _toDisplayString(_ctx.$t('boardCard.promote')), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_22, [
      _createVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('boardCard.costForOtherPlayers')), 1),
      _createVNode("div", _hoisted_24, [
        _createVNode("div", _hoisted_25, [
          _createVNode("span", {
            class: "board-card-description__category",
            style: _ctx.getCategoryStyles(_ctx.upgradeConfig.categoryOne[_ctx.$i18n.locale])
          }, _toDisplayString(_ctx.upgradeConfig.categoryOne[_ctx.$i18n.locale]), 5),
          _createVNode("span", null, _toDisplayString(_ctx.prices.categoryOne.charge), 1)
        ]),
        _createVNode("div", _hoisted_26, [
          _createVNode("span", {
            class: "board-card-description__category",
            style: _ctx.getCategoryStyles(_ctx.upgradeConfig.categoryTwo[_ctx.$i18n.locale])
          }, _toDisplayString(_ctx.upgradeConfig.categoryTwo[_ctx.$i18n.locale]), 5),
          _createVNode("span", null, _toDisplayString(_ctx.prices.categoryTwo.charge), 1)
        ]),
        _createVNode("div", _hoisted_27, [
          _createVNode("span", {
            class: "board-card-description__category",
            style: _ctx.getCategoryStyles(_ctx.upgradeConfig.categoryThree[_ctx.$i18n.locale])
          }, _toDisplayString(_ctx.upgradeConfig.categoryThree[_ctx.$i18n.locale]), 5),
          _createVNode("span", null, _toDisplayString(_ctx.prices.categoryThree.charge), 1)
        ]),
        _createVNode("div", _hoisted_28, [
          _createVNode("span", {
            class: "board-card-description__category",
            style: _ctx.getCategoryStyles(_ctx.upgradeConfig.categoryFour[_ctx.$i18n.locale])
          }, _toDisplayString(_ctx.upgradeConfig.categoryFour[_ctx.$i18n.locale]), 5),
          _createVNode("span", null, _toDisplayString(_ctx.prices.categoryFour.charge), 1)
        ])
      ])
    ])
  ]))
})